export class BuscarImagenBoleta {
    imgTpo: string = '';
    cnv: string = '';
    emp: string = '';
    clt: string = '';
}